import { LocaleLink as Link } from '@/components/LocaleLink'
import { PageShell } from '@/components/layout/PageShell'
import { useTranslation } from '@/lib/i18n/LocaleContext'

/** Rendered by every 404 path (unknown URL, missing CMS doc, unknown locale
 *  prefix) — always with a real 404 status set by the route's loader. */
export default function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <PageShell>
      <section className="block not-found">
        <div className="wrap">
          <p className="not-found-code">{t.common.notFound}</p>
          <h1 className="lede">{t.common.notFoundMsg}</h1>
          <Link to="/" className="btn btn-primary">{t.common.toFrontpage}</Link>
        </div>
      </section>
    </PageShell>
  )
}
